import React from 'react';
import { Container } from './styled';
import { Footer } from '../../components';
import { MdOutlineContentCopy } from 'react-icons/md';
import { toast } from 'react-toastify';
import { handCopyLinkCall } from '../../../../utils/handCopy';

export function Text(props) {

    const { message, className } = props;

    const formatTextWithLinks = (text) => {
        const parts = text.split(/(https?:\/\/\S+)/g);
        return parts.map((part, index) => {
            if (part.match(/https?:\/\/\S+/)) {
                return (
                    <a
                        key={index}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#0d8ae7' }}
                    >
                        {part}
                    </a>
                );
            }

            return part.replace(/\*/g, ' ');
        });
    };

    const handCopy = (token) => {
        const status = handCopyLinkCall(token)
        if (status) {
            toast.success('link copiado', { position: "top-right", autoClose: 5000, icon: <MdOutlineContentCopy /> });
        }
    }

    return (
        <Container
            className={className}
            isUserSystem={message?.user_system ? true : false}
        >
            <div>
                <p>
                    {formatTextWithLinks(message.body)}
                </p>
                {('token' in message) && message.token &&
                    <div className='copy--token'>
                        <button onClick={() => handCopy(message.token)}>
                            <MdOutlineContentCopy />
                            {`Copiar Link`}
                        </button>
                    </div>
                }
            </div>
            <Footer message={message} />
        </Container>
    );
}